import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("删除")

import {
    edit_invoice_template,
    get_invoice_template_list,
    get_invoice_template_detail,
    edit_invoice_template_detail,
  } from '@/api/erp-invoice';
  import { DialogConfig, DialogFormItem } from '@/components/WeDialog/types';
  import { useTable } from '@/components/WeTable';
  import { useApp } from '@/hooks/useApp';
  import { useAppInfo } from '@/hooks/useAppInfo';
  import { useJump } from '@/hooks/useJump';
  import { appStore } from '@/store/modules/app';
  import { isEmptyData } from '@/utils/common';
  import { required, uploadRequired } from '@/utils/validate';
  import omit from 'lodash-es/omit';
  import invert from 'lodash-es/invert';
  import { computed, ref, watch } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { $showAlert, $showDialog } = useApp();
  const { model, getModelItems, appInfo, apiRoot } = useAppInfo();
  const { jumpToWebeye } = useJump();
  const tab = ref('主体-模板配置');
  const columns = computed(() => {
    if (tab.value == '主体-模板配置') {
      return [
        {
          title: '我方主体',
          dataIndex: 'rd_we_company_name',
          componentType: 'a-select',
          slots: { customRender: 'we_company_id' },
        },
        {
          title: '发票模板',
          dataIndex: 'rd_template_type',
          componentType: 'a-select',
        },
        {
          title: '操作',
          dataIndex: 'action',
          flag: 'ACTION',
          slots: {
            customRender: 'action',
          },
        },
      ];
    } else {
      return [
        {
          title: '业务',
          dataIndex: 'rd_logic_type',
          componentType: 'a-select',
        },
        {
          title: '模板logo',
          dataIndex: 'rd_logo_name',
          hiddenFilter: true,
          slots: { customRender: 'rd_logo_name' },
        },
        {
          title: '描述',
          dataIndex: 'desc',
        },
        {
          title: '操作',
          dataIndex: 'action',
          flag: 'ACTION',
          slots: {
            customRender: 'action',
          },
        },
      ];
    }
  });
  const [register, { getDataSource }] = useTable({
    title: '主体发票配置',
    tabConfig: {
      tabItems: [
        { tab: '主体-模板配置', key: '主体-模板配置' },
        { tab: '业务-细节配置', key: '业务-细节配置' },
      ],
    },
    columns,
  });

  const data_source = ref<Recordable[]>([]);

  const template_type_items = computed(() => {
    return getModelItems(model.value.InvoiceTemplate.TEMPLATE_TYPE);
  });
  const we_company_id_items = computed(() => {
    return appInfo.value.we_company_list.map((m) => ({ id: m.id, name: m.name }));
  });
  function edit_template_record(record, is_deleted = false) {
    const is_add = isEmptyData(record);
    if (is_deleted) {
      $showAlert('警告', '确定删除吗？', () => {
        edit_invoice_template({ id: record.id, is_deleted }).then(() => {
          appStore.SET_ALERT_CONFIG(null);
          init_data();
        });
      });
    } else {
      const data_source = getDataSource();
      const existed_template_type_items = data_source.map((item) => item.we_company_id);
      let template_type_list = we_company_id_items.value.filter(
        (item) => !existed_template_type_items.includes(item.id)
      );
      if (!is_add) {
        template_type_list.unshift({ id: record.we_company_id, name: record.rd_we_company_name });
      }
      const inputs: DialogFormItem[] = [
        {
          label: '我方主体',
          result: is_add ? 'we_company_ids' : 'we_company_id',
          type: 'select',
          mode: is_add ? 'multiple' : '',
          rules: [required()],
          items: template_type_list,
          width: 24,
        },
        {
          label: '发票模板',
          result: 'template_type',
          type: 'select',
          rules: [required()],
          items: template_type_items.value,
          width: 24,
        },
      ];
      const dialog: DialogConfig = {
        title: is_add ? '新增主体-模板配置' : '编辑主体-模板配置',
        width: '600px',
        labelCol: '80px',
        init: record,
        blocks: [
          {
            type: 'input',
            value: inputs,
          },
        ],
        callback(result) {
          let params = { ...record, ...result };
          edit_invoice_template(params).then(() => {
            appStore.SET_WE_DIALOG(null);
            init_data();
          });
        },
      };
      $showDialog(dialog);
    }
  }
  function edit_logic_type_record(record, is_deleted = false) {
    const is_add = isEmptyData(record);
    if (is_deleted) {
      $showAlert('警告', '确定删除吗？', () => {
        edit_invoice_template_detail({ id: record.id, is_deleted }).then(() => {
          appStore.SET_ALERT_CONFIG(null);
          init_data();
        });
      });
    } else {
      let logic_type_list = getModelItems(invert(appInfo.value.code_const.INVOICE_TEMPLATE_LOGIC_TYPE), true);
      if (!is_add) {
        record.logo = { name: record.rd_logo_name, id: record.logo_id, base64_data: '' };
      } else {
        const exist_logic_type_list = data_source.value.map((x) => x.logic_type);
        logic_type_list = logic_type_list.filter((x) => !exist_logic_type_list.includes(x.value));
      }
      const inputs: DialogFormItem[] = [
        {
          label: '业务',
          result: is_add ? 'logic_types' : 'logic_type',
          type: 'select',
          mode: is_add ? 'multiple' : '',
          disabled: !is_add,
          rules: [required()],
          items: logic_type_list,
          width: 24,
        },
        {
          label: '描述',
          result: 'desc',
          type: 'text',
          init: !isEmptyData(record) ? record.desc : 'Service',
          rules: [required()],
          width: 24,
        },
      ];
      const dialog: DialogConfig = {
        title: is_add ? '新增业务-细节配置' : '编辑业务-细节配置',
        width: '600px',
        labelCol: '80px',
        init: record,
        blocks: [
          {
            type: 'input',
            value: inputs,
          },
          {
            type: 'backend_oss_upload',
            label: '模板logo',
            result: 'logo',
            rules: [uploadRequired],
            width: 24,
          },
        ],
        callback(result) {
          let params = { ...record, ...result };
          if (!params.logo.base64_data) {
            params = omit(params, 'logo');
          }
          edit_invoice_template_detail(params).then(() => {
            appStore.SET_WE_DIALOG(null);
            init_data();
          });
        },
      };
      $showDialog(dialog);
    }
  }
  function edit_record(record, is_deleted = false) {
    if (tab.value == '主体-模板配置') {
      edit_template_record(record, is_deleted);
    } else {
      edit_logic_type_record(record, is_deleted);
    }
  }
  function init_data() {
    if (tab.value == '主体-模板配置') {
      get_invoice_template_list().then((res) => {
        data_source.value = res;
      });
    } else {
      get_invoice_template_detail().then((res) => {
        data_source.value = res;
      });
    }
  }
  function open_url(code) {
    window.open(`${apiRoot.value}/inner_file/${code}`);
  }
  init_data();
  watch(
    () => tab.value,
    () => {
      init_data();
    }
  );

return (_ctx: any,_cache: any) => {
  const _component_AButton = _resolveComponent("AButton")!
  const _component_WeTable = _resolveComponent("WeTable")!
  const _component_PageWrapper = _resolveComponent("PageWrapper")!

  return (_openBlock(), _createBlock(_component_PageWrapper, null, {
    default: _withCtx(() => [
      _createVNode(_component_WeTable, {
        onRegister: _unref(register),
        activeKey: tab.value,
        "onUpdate:activeKey": _cache[1] || (_cache[1] = ($event: any) => ((tab).value = $event)),
        dataSource: data_source.value
      }, {
        headerButton: _withCtx(() => [
          _createVNode(_component_AButton, {
            type: "primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (edit_record({})))
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        we_company_id: _withCtx(({ record, text }) => [
          _createVNode(_component_AButton, {
            type: "link",
            onClick: ($event: any) => (_unref(jumpToWebeye)(record.we_company_id))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(text), 1)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        rd_logo_name: _withCtx(({ record, text }) => [
          _createVNode(_component_AButton, {
            type: "link",
            onClick: ($event: any) => (open_url(record.rd_logo_code))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(text), 1)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        action: _withCtx(({ record }) => [
          _createVNode(_component_AButton, {
            type: "link",
            onClick: ($event: any) => (edit_record(record))
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 2
          }, 1032, ["onClick"]),
          _createVNode(_component_AButton, {
            type: "link",
            danger: "",
            onClick: ($event: any) => (edit_record(record, true))
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        _: 1
      }, 8, ["onRegister", "activeKey", "dataSource"])
    ]),
    _: 1
  }))
}
}

})